import { Button, Box } from '@rsos/base-components';
import { LiveVideoButtonContainer } from '../VideoTo911/LiveVideoButtonContainer';
import TF911EndChat from './TF911EndChat';
import TF911StartChatAccordion from './TF911StartChatAccordion';

interface TF911ChatHeaderButtonsProps {
  isFetchingMetadata: boolean;
  showStartChat: boolean;
  isCreatingConversation: boolean;
  hasAccessToUniteEventPane: boolean;
  isForOverview: boolean;
  onClickShowAccordion: () => void;
  onStartConversation: (message: string) => Promise<{ isSuccess: boolean }>;
  isChatBoxVisible: boolean;
  selectedCallerID: string;
  showPreconfiguredMessages: boolean;
  gpxFeature?: 'text_from_911'; // EGL-216: For some reason it only accepts this string specifically
}

const TF911ChatHeaderButtons = ({
  isFetchingMetadata,
  showStartChat,
  isCreatingConversation,
  hasAccessToUniteEventPane,
  isForOverview,
  onClickShowAccordion,
  onStartConversation,
  selectedCallerID,
  showPreconfiguredMessages,
  gpxFeature,
}: TF911ChatHeaderButtonsProps) => {
  if (isFetchingMetadata) {
    return (
      <Box mt="8px" width="100%" height="100%" px="12px" pb="16px">
        <Box
          alignSelf="center"
          horizontal
          width="100%"
          borderRadius="0 0 5px 5px"
        >
          <Button
            btnType="tertiary"
            disabled={isFetchingMetadata}
            isLoadingProp={isFetchingMetadata}
            noMargin
            size="med"
            grow
          />
        </Box>
      </Box>
    );
  } else if (showStartChat) {
    return (
      <TF911StartChatAccordion
        isCreatingConversation={isCreatingConversation}
        isUniteEventPaneEnabled={hasAccessToUniteEventPane}
        isForOverview={isForOverview}
        onClickShowAccordion={onClickShowAccordion}
        onStartConversation={onStartConversation}
        showPreconfiguredMessages={showPreconfiguredMessages}
        gpxFeature={gpxFeature}
      />
    );
  } else {
    return (
      <Box horizontal gridColumnGap="8px" mt="8px" px="12px" width="100%">
        {hasAccessToUniteEventPane && (
          <LiveVideoButtonContainer
            onStartConversation={onStartConversation}
            isForOverview={isForOverview}
          />
        )}
        <TF911EndChat
          callerID={selectedCallerID}
          isForOverview={isForOverview}
          isUniteEventPaneEnabled={hasAccessToUniteEventPane}
          gpxFeature={gpxFeature}
        />
      </Box>
    );
  }
};

export default TF911ChatHeaderButtons;
